import { NgModule } from '@angular/core';
import { CommonModule, } from '@angular/common';
import { BrowserModule  } from '@angular/platform-browser';
import { Routes, RouterModule } from '@angular/router';
import { SignupPageComponent } from './pages/signup-page/signup-page.component';
import { AdminMainPageRoutingModule } from './pages/admin-main/admin-main-routing.module';
import { IsLoggedInGuard } from './auth/guards/is-logger-in/is-logged-in.guard';
import { RedirectComponent } from './redirect.component';
import { LocationGuard } from './auth/guards/location/location.guard';

const routes: Routes =[
    { 
      path: 'admin',            
      loadChildren: () => AdminMainPageRoutingModule, 
      canLoad: [IsLoggedInGuard], canActivateChild: [LocationGuard]
    },
    { 
      path: 'signin',           
      component: SignupPageComponent 
    },
    { 
      path: 'signup',           
      component: SignupPageComponent 
    },
    { 
      path: 'reset',            
      component: SignupPageComponent 
    },
    { 
      path: 'r/:shortUrl',      
      component: RedirectComponent 
    },
    { 
      path: '**', 
      redirectTo: 'admin', 
      pathMatch: 'full' 
    }
];

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes,{
      useHash: false
    })
  ],
  exports: [
  ],
})
export class AppRoutingModule { }
